module.exports = __webpack_public_path__ + "applewatch.64497b5200fd7e80d135.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/images/cards/applewatch.png
// module id = ../../../../../src/assets/images/cards/applewatch.png
// module chunks = 0